// Crash reporting through Sentry. Off unless REACT_APP_SENTRY_DSN is set at
// build time, and the library is only downloaded when it is.
//
// Reports carry the error, where in the code it happened, the app version and
// the device type. They never carry the plan: no breadcrumbs (which would
// record clicks, console output and request URLs), no user identity, no cookies.

const DSN = process.env.REACT_APP_SENTRY_DSN;
const enabled = !!DSN && process.env.NODE_ENV === 'production';

let sentry = null;

export function initCrashReporting() {
  if (!enabled) return;
  import('@sentry/react').then((Sentry) => {
    Sentry.init({
      dsn: DSN,
      sendDefaultPii: false,
      tracesSampleRate: 0,
      integrations: (defaults) => defaults.filter((integration) => integration.name !== 'Breadcrumbs'),
      beforeSend(event) {
        delete event.user;
        delete event.breadcrumbs;
        if (event.request) {
          delete event.request.cookies;
          delete event.request.headers;
          // The address can hold a sign-in token on return from a provider.
          if (event.request.url) event.request.url = event.request.url.split(/[?#]/)[0];
        }
        return event;
      },
    });
    sentry = Sentry;
  }).catch(() => {
    // Reporting is best-effort; the app works without it.
  });
}

export function reportError(error, context) {
  if (sentry) sentry.captureException(error, context ? { extra: context } : undefined);
}
